var map = {
	"./Base": 720,
	"./Base/": 720,
	"./Base/index": 720,
	"./Base/index.js": 720,
	"./Base/style": 175,
	"./Base/style.js": 175,
	"./Clutch": 425,
	"./Clutch/": 425,
	"./Clutch/index": 425,
	"./Clutch/index.js": 425,
	"./Clutch/renderComponent": 1625,
	"./Clutch/renderComponent.js": 1625,
	"./Clutch/style": 1283,
	"./Clutch/style.js": 1283,
	"./NewUi": 1004,
	"./NewUi/": 1004,
	"./NewUi/index": 1004,
	"./NewUi/index.js": 1004,
	"./NewUi/style": 1284,
	"./NewUi/style.js": 1284,
	"./OldUi": 1005,
	"./OldUi/": 1005,
	"./OldUi/index": 1005,
	"./OldUi/index.js": 1005,
	"./OldUi/renderComponent": 1626,
	"./OldUi/renderComponent.js": 1626,
	"./OldUi/style": 1285,
	"./OldUi/style.js": 1285,
	"./SpireonNew": 1006,
	"./SpireonNew/": 1006,
	"./SpireonNew/index": 1006,
	"./SpireonNew/index.js": 1006,
	"./SpireonNew/renderComponent": 1627,
	"./SpireonNew/renderComponent.js": 1627,
	"./SpireonNew/style": 1286,
	"./SpireonNew/style.js": 1286,
	"./SpireonOld": 1007,
	"./SpireonOld/": 1007,
	"./SpireonOld/index": 1007,
	"./SpireonOld/index.js": 1007,
	"./SpireonOld/renderComponent": 1628,
	"./SpireonOld/renderComponent.js": 1628,
	"./SpireonOld/style": 1287,
	"./SpireonOld/style.js": 1287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;